import type { MantineThemeOverride } from '@mantine/core';

// Centralized Mantine theme tokens and sensible defaults for the app.
// Follow project guidelines: use theme tokens (spacing md, radius xl, shadows md),
// avoid hardcoded colors and inline styles in components.
export const mantineTheme: MantineThemeOverride = {
  primaryColor: 'indigo',
  fontFamily: 'Inter, Arial, Helvetica, sans-serif',
  headings: {
    fontFamily: 'Inter, Arial, Helvetica, sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '28px', fontWeight: '700' },
      h2: { fontSize: '22px', fontWeight: '700' },
      h3: { fontSize: '18px', fontWeight: '700' },
      h4: { fontSize: '16px', fontWeight: '600' },
      h5: { fontSize: '14px', fontWeight: '600' },
    },
  },
  // Use Mantine tokens for spacing and radii
  spacing: { xs: '8px', sm: '12px', md: '16px', lg: '20px', xl: '24px' },
  radius: { xs: '6px', sm: '8px', md: '12px', lg: '16px', xl: '20px' },
  fontSizes: { xs: '13px', sm: '15px', md: '18px', lg: '20px', xl: '22px' },
  shadows: {
    xs: '0 1px 2px rgba(0,0,0,0.04)',
    sm: '0 2px 6px rgba(0,0,0,0.06)',
    md: '0 6px 18px rgba(0,0,0,0.08)',
  },
  colors: {
    body: [
      '#ffffff',
      '#f7f9fb',
      '#e0e0e0',
      '#cbd5e1',
      '#94a3b8',
      '#64748b',
      '#475569',
      '#334155',
      '#18191a',
      '#0f172a',
    ],
    surface: [
      '#f7f9fb',
      '#e0e0e0',
      '#cbd5e1',
      '#94a3b8',
      '#64748b',
      '#475569',
      '#334155',
      '#18191a',
      '#0f172a',
      '#232326',
    ],
    text: [
      '#0f172a',
      '#18191a',
      '#334155',
      '#475569',
      '#64748b',
      '#94a3b8',
      '#cbd5e1',
      '#e0e0e0',
      '#f7f9fb',
      '#ffffff',
    ],
    border: [
      'rgba(15,23,42,0.06)',
      'rgba(15,23,42,0.12)',
      'rgba(15,23,42,0.18)',
      'rgba(15,23,42,0.24)',
      'rgba(15,23,42,0.30)',
      'rgba(255,255,255,0.08)',
      'rgba(255,255,255,0.16)',
      'rgba(255,255,255,0.24)',
      'rgba(255,255,255,0.32)',
      'rgba(255,255,255,0.40)',
    ],
    primary: [
      '#4f46e5',
      '#6366f1',
      '#818cf8',
      '#a5b4fc',
      '#c7d2fe',
      '#e0e7ff',
      '#f1f5ff',
      '#f7f9fb',
      '#232326',
      '#18191a',
    ],
    muted: [
      '#64748b',
      '#94a3b8',
      '#a3a3a3',
      '#cbd5e1',
      '#e0e0e0',
      '#f7f9fb',
      '#18191a',
      '#232326',
      '#334155',
      '#475569',
    ],
  },
  components: {
    Card: {
      defaultProps: { radius: 'xl', shadow: 'md', p: 'md' },
    },
    Paper: {
      defaultProps: { radius: 'xl', shadow: 'md', p: 'md' },
    },
    Button: {
      defaultProps: { radius: 'xl', size: 'md' },
    },
    ActionIcon: {
      defaultProps: { radius: 'xl', size: 'md' },
    },
  },
};

export default mantineTheme;
